import { Chip } from "@mui/material";

import { AppointmentExchangeOfferStatus } from "@/api";
import { useTranslation } from "@/translations";

interface Props {
  status: AppointmentExchangeOfferStatus;
}

/** "Getauscht" for the accepted offer, "Abgelehnt" for a rejected one; open and withdrawn offers carry no chip. */
export function ExchangeOfferStatusChip({ status }: Props) {
  const { t } = useTranslation();

  if (status === AppointmentExchangeOfferStatus.Accepted) {
    return <Chip size="small" color="primary" label={t("exchange.offersDialog.offerStatus.accepted")} />;
  }
  if (status === AppointmentExchangeOfferStatus.Rejected) {
    return <Chip size="small" variant="outlined" label={t("exchange.offersDialog.offerStatus.rejected")} />;
  }
  return null;
}
